import { Fragment } from "react";

// Mui
import Typography from "@mui/material/Typography";

function CurrencySum(props) {
  let { name, sum, code } = props;

  return (
    <Fragment>
      {name && (
        <Typography
          sx={{ fontWeight: 600, fontSize: "14px" }}
          color="main"
          variant="body1"
        >
          {name}
        </Typography>
      )}

      <Typography variant="subtitle2">
        {`${formatPrice(sum)} ${code}`}
      </Typography>
    </Fragment>
  );
}

function formatPrice(price) {
  return new Intl.NumberFormat("ru-RU").format(price);
}

export default CurrencySum;
